module.exports = __webpack_public_path__ + "static/1-106b7d8858b051113aae459d2ccc9932.webp";